export default "__VITE_ASSET__DSynN6uq__"